export default __webpack_public_path__ + "static/media/004.ab6c1576.png";